module.exports = __webpack_public_path__ + "assets/img/word.83255ccb.png";